const SvgTaskNew = props => (
  <svg width={24} height={24} viewBox='0 0 24 24' {...props}>
    <path d='M21 12a1 1 0 01-2 0H5v5a1 1 0 001 1h7a1 1 0 010 2H6a3 3 0 01-3-3V6a3 3 0 013-3h1a1 1 0 112 0h6a1 1 0 012 0h1a3 3 0 013 3v6zm-2-2V6a1 1 0 00-1-1h-1a1 1 0 01-2 0H9a1 1 0 11-2 0H6a1 1 0 00-1 1v4h14zm1 7h2a1 1 0 010 2h-2v2a1 1 0 01-2 0v-2h-2a1 1 0 010-2h2v-2a1 1 0 012 0v2z' />
  </svg>
);

export default SvgTaskNew;
